export const LOAD_GIFTS_LOCATIONS = "LOAD_GIFTS_LOCATIONS";
